import * as Yup from 'yup';

export const schema = Yup.object().shape({
  mall_acc_id: Yup.number().required(),
  lane: Yup.string(),
  lpr_id: Yup.number().required(),
  lpr_cat_id: Yup.number().required(),
  direction: Yup.string().required()
});

export const formInitialState = {
  mall_acc_id: '',
  lane: '',
  lpr_id: '',
  lpr_cat_id: '',
  direction: '',
  active: false
};

export const formErrorInitialState = {
  mall_acc_idError: false,
  laneError: false,
  lpr_idError: false,
  lpr_cat_idError: false,
  directionError: false
};
